export default "__VITE_PUBLIC_ASSET__e9ed16c5__"